import mapKnownValues from "@/utils/mapKnownValues";
import { defaultDateTimeFormat } from "@/utils/defaultDateFormat";
import { roundNumber } from "@/utils/round";
import { optionalDisplayValue } from "@/utils/optionalDisplayValue";
import makeClassAttrsEnumerable from "@/utils/makeClassAttrsEnumerable";
import formatNumberAsCurrency from "@/utils/formatNumberAsCurrency";

export type StationSubTransactionAPIResponse = {
  id: string;
  transactionId: number;
  startAt?: string;
  stopAt?: string;
  meterStart?: number;
  meterStop?: number;
  pricingPolicy?: string;
  phaseKey?: string;
  costPennies: number;
  totalWH: number;
};

export default class StationSubTransaction {
  id = "";
  transactionId = "";
  startAt = "";
  stopAt = "";
  meterStart = 0;
  meterStop = 0;
  pricingPolicy = "";
  phaseKey = "";
  costPennies = 0;
  totalWH = 0;

  constructor(params: Partial<StationSubTransactionAPIResponse> | StationSubTransaction = {}) {
    mapKnownValues(this, params);
    makeClassAttrsEnumerable.bind(this)(StationSubTransaction, ["formatted"]);
  }

  get formatted() {
    return {
      costPennies: formatNumberAsCurrency(this.costPennies / 100),
      totalKWH: roundNumber(this.totalWH / 1000, 2),
      meterStart: roundNumber(this.meterStart, 2),
      meterStop: roundNumber(this.meterStop, 2),
      startAt: optionalDisplayValue(this.startAt, defaultDateTimeFormat(new Date(this.startAt))),
      stopAt: optionalDisplayValue(this.stopAt, defaultDateTimeFormat(new Date(this.stopAt)))
    };
  }
}
